export default __webpack_public_path__ + "static/media/iyyara_banner.e177a01e.png";